import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "list-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "title-ellipsis" }
const _hoisted_4 = { class: "track-title" }
const _hoisted_5 = {
  key: 0,
  class: "track-artist"
}
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = {
  key: 0,
  class: "bi bi-pause button-icon"
}
const _hoisted_8 = {
  key: 1,
  class: "bi bi-play-fill button-icon"
}

import { ref, watch } from "vue";
import IconButton from "@/components/common-ui/buttons/IconButton.vue";
import FiloxeniaIcon from "@/components/common-ui/icons/FiloxeniaIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListItemAudio',
  props: /*@__PURE__*/_mergeModels({
    title: {},
    artist: {},
    coverUrl: {},
    selected: { type: Boolean, default: false }
  }, {
    "playing": { type: Boolean, ...{
  required: true,
} },
    "playingModifiers": {},
  }),
  emits: ["update:playing"],
  setup(__props: any) {



const isPlaying = _useModel<boolean>(__props, "playing");

const coverFailed = ref(false);

watch(
  () => __props.coverUrl,
  () => {
    coverFailed.value = false;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (__props.coverUrl && !coverFailed.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.coverUrl,
            alt: "",
            class: "square",
            onError: _cache[0] || (_cache[0] = ($event: any) => (coverFailed.value = true))
          }, null, 40, _hoisted_2))
        : (_openBlock(), _createBlock(FiloxeniaIcon, {
            key: 1,
            name: "MusicNote",
            class: "square",
            style: {"color":"#ffc36e1f"}
          }))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
      (__props.artist)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.artist), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(IconButton, {
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isPlaying.value = !isPlaying.value), ["stop"])),
        inverted: __props.selected
      }, {
        default: _withCtx(() => [
          (isPlaying.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
            : (_openBlock(), _createElementBlock("i", _hoisted_8))
        ]),
        _: 1
      }, 8, ["inverted"])
    ])
  ]))
}
}

})